import * as React from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

export default function LandLinePhoneFormatter({
  name,
  control,
  onErrorCheck,
}) {
  // Function to format the value with thousand separators and add the prefix
  const formatNumber = (value) => {
    if (!value) return "";

    // Malaysian landline numbers
    if (value.length >= 9) {
      // Match landline numbers (e.g., 03-XXXXXXX or 088-XXXXXXX)
      let match = value.match(/^(\d{2,3})(\d{7})$/); // Match 2-3 digit area code and 7-digit number

      if (match) {
        return match[1] + "-" + match[2]; // Format as area code followed by number
      }
    }
    return value; // Add $ prefix and thousand separator
  };

  // Function to extract numeric value from formatted input
  const extractNumericValue = (value) => {
    // Remove non-numeric characters except for the decimal point
    return value.replace(/[^0-9]/g, "");
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue="" // Default empty value
      rules={{ required: false }} // Validation rules
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          value={formatNumber(value)} // Format the value with prefix and thousand separators
          onChange={(event) => {
            // Extract numeric value from the input
            const numericValue = extractNumericValue(event.target.value);

            // Call react-hook-form onChange with the raw numeric value
            onChange(numericValue);
          }}
          name={name}
          id="formatted-numberformat-input"
          helperText={error ? error.message : onErrorCheck} // Helper text for error
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              fontSize: "16px",
              borderRadius: "25px",
              color: "black", // Set the input text color to black
              backgroundColor: "white", // Set background color to white
              "& fieldset": {
                borderColor: "#ccc", // Default border color
              },
              "&:hover fieldset": {
                borderColor: "#999", // Border color on hover
              },
              // "&.Mui-focused fieldset": {
              //   borderColor: "transparent", // Border color on focus
              //   outline: "none", // Remove outline on focus
              // },
            },
          }}
          error={Boolean(onErrorCheck)}

          // Ensuring the input type is number and restricting other input
          // inputProps={{ inputMode: "numeric" }}
        />
      )}
    />
  );
}
